module.exports = __webpack_public_path__ + "static/img/moments_image1.6693013.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/moments_image1.png
// module id = loEl
// module chunks = 1